<template>
    <div class="query-builder dynamic-form">
        <template v-for="(search, fieldName) in query">
            <query-term v-bind:fieldName="fieldName" v-bind:type.sync="search.type" v-bind:params.sync="search.value" v-bind:field="searchSpec.fields[fieldName]" v-on:update:type="update()" v-on:update:params="update()">
                <span class="remove glyphicon glyphicon-remove" v-on:click="removeField(fieldName)"></span>
            </query-term>
        </template>
        <div class="form-group">
            <label>Add Field:</label>
            <select v-model="addFieldName" v-on:change="addField()" class="form-control">
                <option value=""></option>
                <optgroup v-for="group in inactiveFields" v-bind:label="group.label">
                    <option v-for="field in group.fields" v-bind:value="field.name" :key="field.name">{{field.label}}</option>
                </optgroup>
            </select>
        </div>
    </div>
</template>

<script>
    import QueryTerm from '@/components/search/QueryTerm'

    export default {
        props: ['searchSpec', 'value'],
        name: 'QueryBuilder',
        components: {QueryTerm},
        data () {
            return {
                addFieldName: null,
                inactiveFields: []
            }
        },
        computed: {
            query: {
                get () {
                    return this.value
                },
                set (newValue) {
                    this.$emit('input', newValue)
                }
            }
        },
        methods: {
            updateInactiveFields: function () {
                this.inactiveFields = {}

                for (let field in this.searchSpec.fields) {
                    if (this.query[field] === undefined) {
                        if (this.inactiveFields[this.searchSpec.fields[field].group] === undefined) {
                            this.inactiveFields[this.searchSpec.fields[field].group] = {
                                label: this.searchSpec.groups[this.searchSpec.fields[field].group] || this.searchSpec.fields[field].group,
                                fields: []
                            }
                        }

                        this.inactiveFields[this.searchSpec.fields[field].group].fields.push({
                            name: field,
                            label: this.searchSpec.fields[field].label || field
                        })
                    }
                }
            },
            addField () {
                if (this.addFieldName) {
                    this.query[this.addFieldName] = {type: this.searchSpec.fields[this.addFieldName].availableTypes[0].name, value: null}
                    this.addFieldName = null
                    this.updateInactiveFields()
                }
            },
            removeField (fieldName) {
                delete this.query[fieldName]
                this.updateInactiveFields()
            },
            update () {
                this.$forceUpdate()
            }
        },
        created () {
            this.updateInactiveFields()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// QueryBuilder.vue?7477b81e